<template>
  <div class="task-files-section" data-testid="task-files-section">
    <div class="task-files-section__header">
      <span class="task-files-section__title">Files</span>
      <button
        v-if="canUpload"
        type="button"
        class="task-files-section__upload-btn"
        data-testid="task-files-section__upload-btn"
        @click="$emit('open-upload')"
      >
        <img
          src="/img/icons/fbc-icons/UploadIcon.svg"
          alt=""
          aria-hidden="true"
          class="task-files-section__upload-icon"
        />
        <span>Upload File</span>
      </button>
    </div>

    <TaskFilesList
      :task="task"
      :can-delete-file="canDeleteFile"
      data-testid="task-files-section__list"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import TaskFilesList from './TaskFilesList.vue';

export default {
  name: 'TaskFilesSection',

  components: { TaskFilesList },

  props: {
    task: { type: Object, required: true },
    capabilities: {
      type: Object,
      default: () => ({
        can_submit: false,
      }),
    },
  },

  computed: {
    canUpload() {
      return !!this.capabilities?.can_submit;
    },
    canDeleteFile() {
      return !!this.capabilities?.can_submit;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/summary-cards';
@import '../../styles/files-requests';

.task-files-section {
  @include files-requests-panel;
}

.task-files-section__header {
  @include files-requests-panel-header;
}

.task-files-section__title {
  @include files-requests-panel-title;
}

.task-files-section__upload-btn {
  @include files-requests-action-btn;
}

.task-files-section__upload-icon {
  width: var(--space-7);
  height: var(--space-7);
}
</style>
